import tokens from '@gympass/yoga-tokens'

const inputOverrides = {
  MuiOutlinedInput: {
    root: {
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: `${tokens.colors.stamina} !important`,
        borderWidth: '1px',
      },
    },
  },
  MuiFormLabel: {
    root: {
      fontSize: '14px',
      lineHeight: '16px',
      '&.Mui-focused': {
        color: `${tokens.colors.stamina}`,
        fontSize: '16px',
      },
    },
  },
}

export default inputOverrides
